import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function changeTaskStatusReducer(
	state = initialState.changeTaskStatus,
	action
) {
	switch (action.type) {
		case types.CHANGE_TASK_STATUS:
		case types.UPDATE_EP_EQR_SIGNOFF_INFO: {
			return state;
		}
		case types.APPLY_SIGNOFF_AND_CHANGE_TASK_STATUS: {
			return state;
		}
		default:
			return state;
	}
}
